import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Auth0Provider, AppState } from "@auth0/auth0-react";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// You can import config values from a separate file
import authConfig from "./authConfig";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "[::1]";

const isSecureOrigin = window.location.protocol === "https:" || isLocalhost;

if (!isSecureOrigin) {
  const secureUrl = `https://${window.location.host}${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(secureUrl);

  root.render(
    <React.StrictMode>
      <div style={{ fontFamily: "sans-serif", padding: "2rem" }}>
        Redirecting to secure site...
      </div>
    </React.StrictMode>
  );
} else {

  const onRedirectCallback = (appState?: AppState) => {
    const fallbackReturnTo = sessionStorage.getItem('postLoginReturnTo');
    const rawTargetUrl = appState?.returnTo || fallbackReturnTo || '/analytics?pre=1';
    const targetUrl = rawTargetUrl === '/' ? '/analytics?pre=1' : rawTargetUrl;
    window.location.replace(targetUrl);
    sessionStorage.removeItem('postLoginReturnTo');
  };

  root.render(
    <Auth0Provider
      domain={authConfig.domain}
      clientId={authConfig.clientId}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: authConfig.audience // optional
      }}
    >
      <App />
    </Auth0Provider>
  );
}

// Register service worker for PWA functionality
// serviceWorkerRegistration.register();
